<template>
  <section class="section">
    <div class="container">
      <div class="columns">
        <div class="column">
          <h2 class="title">ຂຶ້ນແຜນຕາມຄວາມຕ້ອງການຂອງຕະຫຼາດ - {{ roleid }}</h2>
        </div>
      </div>
      <b-tabs v-model="activeTab" v-if="roleid == 7">
        <b-tab-item label="ແຜນປະຈຳປີ (ລໍຖ້າຮັບ)">
          <b-field group>
            <b-field label="ຄວາມຕ້ອງການປະຈຳປີ"></b-field>
            <b-field style="margin: 0  0 0 15px">
              <b>{{ activePlanYear }} :+ </b></b-field
            >
            <b-field style="margin: 0 15px 0 30px">
              ເລືອກປີ
            </b-field>
            <b-field>
              <b-field label="">
                <Multiselect
                  placeholder="ເລືອກ"
                  v-model.trim="selectedYear"
                  label="NAME"
                  track-by="ID"
                  :options="yearList"
                  @input="onYearSelected"
                >
                </Multiselect>
              </b-field>
            </b-field>
            <b-field style="margin-left: 15px;">
              <b-button
                v-if="contractproductwaitlist.length > 0"
                class="btn-group-margin"
                type="is-primary"
                @click="branchRevievePlans()"
                >ຮັບເອົາແຜນທັງໝົດ
              </b-button>
            </b-field>
          </b-field>
          <div>
            ສາຂາ: {{ userBRANCHNAME }}
            <table class="table is-fullwidth is-narrow is-small">
              <thead>
                <tr>
                  <th class="has-text-centered " width="5%">#</th>
                  <th class="has-text-left " width="20%">
                    ສິນຄ້າ/ ປະເພດ
                  </th>
                  <th class="has-text-left " width="15%">
                    ຈຳນວນ
                  </th>
                  <th class="has-text-left " width="15%">
                    ວັນທີຕ້ອງການ<br />ຜົນຜະລິດ
                  </th>

                  <th class="has-text-left " width="30%">
                    ບ່ອນສົ່ງ
                  </th>
                  <th class="has-text-left " width="30%">
                    ເລືອກແຂວງ
                  </th>
                  <th class="has-text-left " width="10%">
                    ຈັດການ
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="(data, index) in contractproductwaitlist"
                  :key="data.B2BID"
                >
                  <td class="has-text-centered">{{ index + 1 }}</td>
                  <td>{{ data.PRODUCTNAME }}/ {{ data.TYPENAME }}</td>
                  <td>{{ data.B2BAMOUNT }} {{ data.UNIT }}</td>
                  <td>
                    {{ dateFormatter(data.REDATE) }}
                  </td>
                  <td>
                    {{ data.PROVINCENAME }} <br />
                    {{ data.DISTRICT }} {{ data.VILLAGE }}
                  </td>
                  <td>
                    <Multiselect
                      placeholder="ເລືອກແຂວງ"
                      v-model.trim="data.selectedProvince"
                      label="PROVINCENAME"
                      track-by="PROVINCEID"
                      :options="provinceList"
                    >
                    </Multiselect>
                  </td>

                  <td>
                    <b-field>
                      <b-button
                        class="btn-group-margin"
                        type="is-primary"
                        @click="
                          branchRevievePlan(data.B2BID, data.selectedProvince)
                        "
                        >ຮັບເອົາແຜນ
                      </b-button>
                    </b-field>
                    <b-field>
                      <b-button
                        class="btn-group-margin"
                        type="is-danger"
                        @click="branchSendBackPlan(data.B2BID, data.CONTRACTID)"
                        >ປະຕິເສດແຜນ
                      </b-button>
                    </b-field>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </b-tab-item>

        <b-tab-item label="ຈັດສັນແຜນປະຈຳປີ">
          <b-field group>
            <b-field label="ຄວາມຕ້ອງການປະຈຳປີ"></b-field>
            <b-field style="margin: 0  0 0 15px">
              <b>{{ activePlanYear }} </b></b-field
            >
            <b-field style="margin: 0 15px 0 30px">
              ເລືອກປີ
            </b-field>
            <b-field>
              <b-field label="">
                <Multiselect
                  placeholder="ເລືອກ"
                  v-model.trim="selectedYear"
                  label="NAME"
                  track-by="ID"
                  :options="yearList"
                  @input="onYearSelected"
                >
                </Multiselect>
              </b-field>
            </b-field>
          </b-field>
          <div>
            ສາຂາ: {{ userBRANCHNAME }}
            <table class="table is-fullwidth is-narrow is-small">
              <thead>
                <tr>
                  <th class="has-text-centered " width="1%">#</th>
                  <th class="has-text-left " width="5%">
                    ສິນຄ້າ/ປະເພດ
                  </th>
                  <th class="has-text-left " width="2%">
                    ຈຳນວນ
                  </th>
                  <!-- <th class="has-text-left " width="5%">
                          ຍັງເຫຼ່ືອ
                        </th> -->
                  <th class="has-text-left " width="5%">
                    ເກັບຜົນຜະລິດ
                  </th>
                  <!-- <th class="has-text-left " width="5%">
                          ປະເພດ
                        </th> -->

                  <th class="has-text-left " width="5%">
                    ບ່ອນສົ່ງ
                  </th>

                  <th class="has-text-left " width="5%">
                    ຈຳນວນ
                  </th>
                  <th class="has-text-left " width="5%">
                    ແຂວງທີ່ຜະລິດ
                  </th>

                  <th class="has-text-left " width="30%">
                    ເລືອກຊາວກະສິິກອນ
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="(data, index) in contractproductlist"
                  :key="data.B2BID"
                >
                  <td class="has-text-centered">{{ index + 1 }}</td>
                  <td>
                    {{ data.PRODUCTNAME }} <br />
                    {{ data.TYPENAME }}
                  </td>
                  <td>{{ data.B2BAMOUNT }} <br />{{ data.UNIT }}</td>
                  <!-- <td>
                            {{data.REMAINAMOUNT}} <br> {{ data.UNIT }}
                          </td> -->
                  <td>
                    {{ dateFormatter(data.REDATE) }}
                  </td>

                  <td>
                    {{ data.PROVINCENAME }} <br />
                    {{ data.DISTRICT }} {{ data.VILLAGE }}
                  </td>
                  <td>
                    <b-field v-if="data.REMAINAMOUNT > 0">
                      <b-input v-model.trim="data.REMAINAMOUNTFORUSE">
                      </b-input>
                    </b-field>
                    <span
                      v-if="data.PROSTATUS == 2"
                      style="color: red; font-weight: bold"
                    >
                      ຢືນຢັນ<br />ແຜນແລ້ວ
                    </span>
                    <field v-if="data.PROSTATUS == 1 && data.REMAINAMOUNT == 0">
                      <b-button
                        v-if="data.PROSTATUS == 1"
                        class="btn-group-margin"
                        type="is-danger"
                        @click="actionToContractPlanForFarmer(data.B2BID, 0)"
                        >ຍົກເລີກ
                      </b-button>
                    </field>
                    <field v-if="data.PROSTATUS == 1 && data.REMAINAMOUNT == 0">
                      <b-button
                        v-if="data.PROSTATUS == 1"
                        class="btn-group-margin"
                        type="is-primary"
                        @click="actionToContractPlanForFarmer(data.B2BID, 2)"
                        >ຢືນຢັນ
                      </b-button>
                    </field>
                  </td>

                  <td>
                    {{ data.PLANPROVINCE }}
                  </td>

                  <td>
                    <span v-html="data.FARMERNAME"></span>
                    <b-field v-if="data.REMAINAMOUNT > 0">
                      <Multiselect
                        placeholder="ເລືອກຊາວກະສິກອນ"
                        v-model.trim="data.selectedFarmer"
                        label="FARMERNAME"
                        track-by="FARMERID"
                        :options="farmerList"
                        @input="
                          onSelectedFarmer(
                            data.B2BID,
                            data.REMAINAMOUNTFORUSE,
                            data.REMAINAMOUNT,
                            data.PRODUCTID,
                            data.selectedFarmer
                          )
                        "
                      >
                      </Multiselect>
                    </b-field>

                    <b-field v-if="data.REMAINAMOUNT === data.B2BAMOUNT">
                      <b-button
                        class="btn-group-margin"
                        type="is-danger"
                        @click="cancelBranchRevievePlan(data.B2BID)"
                        >ຍົກເລີກແຜນ
                      </b-button>
                    </b-field>
                    <!-- <b-field>
                               <Multiselect
                                placeholder="ເລືອກຟາມ"
                                v-model.trim="data.selectedFarm" 
                                label="FARMNAME"
                                track-by="FARMID"
                                :options="farmList"
                                @input="onSelectedFarm(data.B2BID,data.AMOUNT,data.PRODUCTID,data.selectedFarm)"
                              >
                              </Multiselect>
                            </b-field>   -->
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </b-tab-item>
      </b-tabs>
    </div>
  </section>
</template>

<script>
import RestAPI from "../../RestAPI";
import Multiselect from "vue-multiselect";
import moment from "moment";

export default {
  components: { Multiselect },
  props: ["MONTH"],
  data() {
    return {
      roleid: null,
      userName: null,

      activeb2b: [],

      activeTab: 0,
      saveAction: true,
      updateAction: false,
      adddataform: true,
      updatedataform: false,
      contractlist: [],
      contractproductwaitlist: [],
      contractproductlist: [],
      yearList: [],
      selectedYear: null,
      activePlanYear: null,
      farmerList: [],
      selectedFarmer: [],
      farmList: [],
      selectedFarm: [],
      contractProvinceList: [],
      selectedProvince: null,
      provinceList: [],
    };
  },
  methods: {
    newArray(ID) {
      return this.array2.filter((a2) => a2.ID == ID);
    },

    getContractforDpp() {
      RestAPI.getContractforDpp(2) // 2 send to dpp
        .then((res) => {
          // console.log("list:"+ JSON.stringify(res.data))
          this.contractlist = res.data;
          // this.inactivemarkets = res.data.inactivemarkets;
        })
        .catch((error) => {
          console.log(error);
          this.$swal("ມີຂໍ້ຜິດພາດ", "-", "error");
        });
    },

    getDppContractProductList(year) {
      this.isContractProductList = true;
      // console.log("this.contractid: " + this.contractid)
      RestAPI.getDppContractProductListBranch(year, this.userBRANCHID)
        .then((res) => {
          this.contractproductwaitlist = res.data.wait;
          this.contractproductlist = res.data.list;
          // console.log("products-: " + JSON.stringify(res.data));
        })
        .catch((error) => {
          console.log(error);
          this.$swal("ມີຂໍ້ຜິດພາດ", "-", "error");
        });
    },

    getYearList() {
      RestAPI.getYearList()
        .then((res) => {
          this.yearList = res.data;
        })
        .catch((error) => {
          console.log(error);
          this.$swal("ມີຂໍ້ຜິດພາດ", "-", "error");
        });
    },
    getActivePlanYear() {
      RestAPI.getActivePlanYear()
        .then((res) => {
          this.activePlanYear = res.data[0].NAME;
          this.getDppContractProductList(this.activePlanYear);
          // console.log("activePlanYear: " + res.data[0].NAME)
        })
        .catch((error) => {
          console.log(error);
          this.$swal("ມີຂໍ້ຜິດພາດ", "-", "error");
        });
    },
    onYearSelected() {
      this.activePlanYear = this.selectedYear.NAME;
      this.getDppContractProductList(this.activePlanYear);
    },
    getContractProductProvince() {
      RestAPI.getContractProductProvince(2022, 2)
        .then((res) => {
          this.contractProvinceList = res.data;
          // console.log("contractProvinceList: " + JSON.stringify(this.contractProvinceList))
        })
        .catch((error) => {
          console.log(error);
          this.$swal("ມີຂໍ້ຜິດພາດ", "-", "error");
        });
    },
    getBranchofProduction() {
      RestAPI.getBranches()
        .then((res) => {
          this.branchList = res.data.activebranches;
        })
        .catch((error) => {
          console.log(error);
          this.$swal("ມີຂໍ້ຜິດພາດ", "-", "error");
        });
    },
    getFarmerList() {
      RestAPI.getFarmerList(this.userProvinceID) // ແລ້ວອັບເດດເປັນ branchid ແລະ ໄປຊອກໃນ ຶ branchprovinces
        .then((res) => {
          this.farmerList = res.data;
          // console.log("farmerlist: " + JSON.stringify(this.farmerList))
        })
        .catch((error) => {
          console.log(error);
          this.$swal("ມີຂໍ້ຜິດພາດ", "-", "error");
        });
    },
    onSelectedFarmer(
      requirementid,
      amount,
      remainamount,
      productid,
      selectedFarmer
    ) {
      // this.getFarm(onSelectedFarmer.FARMERID)
      if (amount === null || amount == 0) {
        this.$swal("ກະລູນາປ້ອນຈຳນວນ", "", "error");
      } else if (amount > remainamount) {
        this.$swal("ຈຳນວນທີ່ປ້ອນ ເກີນຈຳນວນຍັງເຫຼ່ືອ", "", "error");
      } else {
        this.$swal({
          title: "ຕ້ອງການຈັດແຜນໃຫ້ຊາວກະສິກອນ ແທ້ບໍ່?",
          showCancelButton: true,
          showCloseButton: true,
          confirmButtonText: "ຕ້ອງການ",
          cancelButtonText: "ບໍ່ຕ້ອງການ",
          confirmButtonColor: "#d33",
          cancelButtonColor: "#3085d6",
        }).then((result) => {
          if (result.value) {
            var params = {
              requirementid: requirementid,
              farmerid: selectedFarmer.FARMERID,
              farmid: selectedFarmer.FARMID,
              amount: amount,
              productid: productid,
              username: this.username,
            };
            // console.log("params: ", JSON.stringify(params))
            RestAPI.setContractPlanForFarmer(params)
              .then(() => {
                this.$swal("ຈັດແຜນໃຫ້ຊາວກະສິກອນ ສຳເລັດ!", "", "success");
                this.getDppContractProductList(this.activePlanYear);
              })
              .catch((error) => {
                console.log(error);
                if (error == "Error: Request failed with status code 400") {
                  this.$swal("Check Input Data", "", "error");
                } else {
                  this.$swal("ມີຂໍ້ຜິດພາດ: " + error, "-", "error");
                }
              });
          }
        });
      }
    },
    actionToContractPlanForFarmer(requirementid, status) {
      this.$swal({
        title: "ຕ້ອງການດຳເນີນການແທ້ບໍ່ ແທ້ບໍ່?",
        showCancelButton: true,
        showCloseButton: true,
        confirmButtonText: "ຕ້ອງການ",
        cancelButtonText: "ບໍ່ຕ້ອງການ",
        confirmButtonColor: "#d33",
        cancelButtonColor: "#3085d6",
      }).then((result) => {
        if (result.value) {
          var params = {
            requirementid: requirementid,
            status: status,
            username: this.username,
          };
          RestAPI.actionToContractPlanForFarmer(params)
            .then(() => {
              this.$swal("ດຳເນີນການ ສຳເລັດ!", "", "success");
              this.getDppContractProductList(this.activePlanYear);
            })
            .catch((error) => {
              console.log(error);
              if (error == "Error: Request failed with status code 400") {
                this.$swal("Check Input Data", "", "error");
              } else {
                this.$swal("ມີຂໍ້ຜິດພາດ: " + error, "-", "error");
              }
            });
        }
      });
    },
    // onSelectedProvince(){
    //   this.selectedProvince = farmid: selectedFarm.FARMID
    // },
    getProvinceofBranch() {
      RestAPI.getProvinceofBranch(this.userBRANCHID)
        .then((res) => {
          this.provinceList = res.data;
          // console.log("farm:" + JSON.stringify(this.farmList))
        })
        .catch((error) => {
          console.log(error);
          this.$swal("ມີຂໍ້ຜິດພາດ", "-", "error");
        });
    },
    getFarm(farmerid) {
      // console.log("farmerid: " + farmerid)
      RestAPI.getFarmList(farmerid)
        .then((res) => {
          this.farmList = res.data;
          // console.log("farm:" + JSON.stringify(this.farmList))
        })
        .catch((error) => {
          console.log(error);
          this.$swal("ມີຂໍ້ຜິດພາດ", "-", "error");
        });
    },
    onSelectedFarm(requirementid, amount, productid, selectedFarm) {
      this.$swal({
        title: "ຕ້ອງການຈັດແຜນໃຫ້ຊາວກະສິກອນ ແທ້ບໍ່?",
        showCancelButton: true,
        showCloseButton: true,
        confirmButtonText: "ຕ້ອງການ",
        cancelButtonText: "ບໍ່ຕ້ອງການ",
        confirmButtonColor: "#d33",
        cancelButtonColor: "#3085d6",
      }).then((result) => {
        if (result.value) {
          var params = {
            requirementid: requirementid,
            farmerid: this.selectedFarmer.FARMERID,
            farmid: selectedFarm.FARMID,
            amount: amount,
            productid: productid,
            username: this.username,
          };
          // console.log("params: ", JSON.stringify(params))
          RestAPI.setContractPlanForFarmer(params)
            .then(() => {
              this.$swal("ຈັດແຜນໃຫ້ຊາວກະສິກອນ ສຳເລັດ!", "", "success");
              this.getDppContractProductList(this.activePlanYear);
            })
            .catch((error) => {
              console.log(error);
              if (error == "Error: Request failed with status code 400") {
                this.$swal("Check Input Data", "", "error");
              } else {
                this.$swal("ມີຂໍ້ຜິດພາດ: " + error, "-", "error");
              }
            });
        }
      });
    },

    branchRevievePlan(B2BID, SELECTEDPROVINCE) {
      if (SELECTEDPROVINCE === undefined) {
        this.$swal("ກະລຸນາເລືອກແຂວງ", "", "error");
      } else {
        var params = {
          requirementid: B2BID,
          provinceid: SELECTEDPROVINCE.PROVINCEID,
          username: this.username,
        };
        RestAPI.branchRevievePlan(params)
          .then(() => {
            this.$swal("ຮັບເອົາແຜນ ສຳເລັດ!", "", "success");
            this.getDppContractProductList(this.activePlanYear);
          })
          .catch((error) => {
            console.log(error);
            if (error == "Error: Request failed with status code 400") {
              this.$swal("Check Input Data", "", "error");
            } else {
              this.$swal("ມີຂໍ້ຜິດພາດ: " + error, "-", "error");
            }
          });
      }
    },

    branchSendBackPlan(B2BID, CONTRACTID) {
      var params = {
        requirementid: B2BID,
        username: this.username,
      };
      // console.log("params: ", JSON.stringify(params))
      RestAPI.branchSendBackPlan(params)
        .then(() => {
          this.$swal("ປະຕິເສດແຜນ ສຳເລັດ!", "", "success");
          this.getDppContractProductList(this.activePlanYear);
          this.checkAllContractProductSendtoBranch(CONTRACTID);
        })
        .catch((error) => {
          console.log(error);
          if (error == "Error: Request failed with status code 400") {
            this.$swal("Check Input Data", "", "error");
          } else {
            this.$swal("ມີຂໍ້ຜິດພາດ: " + error, "-", "error");
          }
        });
    },

    checkAllContractProductSendtoBranch(contractno) {
      var params = {
        contractid: contractno,
        username: this.username,
      };
      // console.log("params: ", JSON.stringify(params))
      RestAPI.checkAllContractProductSendtoBranch(params)
        .then((res) => {
          console.log("res:" + JSON.stringify(res.data));
        })
        .catch((error) => {
          console.log(error);
          if (error == "Error: Request failed with status code 400") {
            this.$swal("Check Input Data", "", "error");
          } else {
            this.$swal("ມີຂໍ້ຜິດພາດ: " + error, "-", "error");
          }
        });
    },

    cancelBranchRevievePlan(B2BID) {
      var params = {
        requirementid: B2BID,
        username: this.username,
      };
      // console.log("params: ", JSON.stringify(params))
      RestAPI.cancelBranchRevievePlan(params)
        .then(() => {
          this.$swal("ຍົກເລີກການຮັບເອົາແຜນ ສຳເລັດ!", "", "success");
          this.getDppContractProductList(this.activePlanYear);
        })
        .catch((error) => {
          console.log(error);
          if (error == "Error: Request failed with status code 400") {
            this.$swal("Check Input Data", "", "error");
          } else {
            this.$swal("ມີຂໍ້ຜິດພາດ: " + error, "-", "error");
          }
        });
    },

    branchRevievePlans() {
      var params = {
        branchid: this.userBRANCHID,
        year: this.activePlanYear,
        username: this.username,
      };
      // console.log("params: ", JSON.stringify(params))
      RestAPI.branchRevievePlans(params)
        .then(() => {
          this.$swal("ຮັບເອົາແຜນທັງໝົດ ສຳເລັດ!", "", "success");
          this.getDppContractProductList(this.activePlanYear);
          this.activeTab = 1;
        })
        .catch((error) => {
          console.log(error);
          if (error == "Error: Request failed with status code 400") {
            this.$swal("Check Input Data", "", "error");
          } else {
            this.$swal("ມີຂໍ້ຜິດພາດ: " + error, "-", "error");
          }
        });
    },

    dateFormatter(date) {
      return new moment(date).format("DD/MM/YYYY");
    },
    dateFormatterYYYYMMDD(date) {
      return new moment(date).format("YYYY-MM-DD");
    },

    print() {
      window.print();
    },
  },
  mounted() {
    this.roleid = this.user.ROLEID;
    this.username = this.user.USERNAME;
    this.userProvinceID = this.user.PROVINCEID;
    this.userBRANCHID = this.user.BRANCHID;
    this.userBRANCHNAME = this.user.BRANCHNAME;
    // this.getB2bUser();
    // this.getCountry();
    this.getActivePlanYear();
    this.getYearList();
    this.getContractforDpp();
    this.getContractProductProvince();
    this.getBranchofProduction();
    this.getFarmerList();
    this.getProvinceofBranch();
    this.selecteddate = new Date();
    this.selectedquotaddate = new Date();
    this.formdate = new Date();
  },
  computed: {
    formdatestr() {
      return new moment(this.formdate).format("YYYY-MM-DD");
    },
  },
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style scoped>
.asterisk {
  color: red;
}
</style>
